/**
 * виджет добавления удаления тегов
 */
import {Widget} from "base/assets/js/widget/Widget.js";
import {FormSearch} from "base/assets/js/widget/FormSearch.js";

export class Query extends Widget{

	/**
	 * @type {FormSearch}
	 */
	_oFormSearch;
	_sQueryItem;
	_bSetted;
	_bAppend = false;

	run() {
		this._my( { item: "_sQueryItem", append: 'b:_bAppend' } );
		this._on( 'Btn[]', 'click', ( oEvent ) => {
			this._oFormSearch.addQueryItemTyped( this._attr( oEvent.currentTarget, 'item' ) );
		} );
		this._on( 'CancelBtn[]', 'click', ( oEvent ) => {
			this._oFormSearch.dropQueryItem( this._sQueryItem );
		} );
		this.reset();
	}
	reset() {
		this._oFormSearch = this._rel( document.body ).child().typeOf( FormSearch ).canEmpty().find();

		this._mod( '', 'lquery_active', !!this._oFormSearch );
		this._mod( '', 'lquery_empty', this._oFormSearch && this._oFormSearch.isEmpty() );

		if( this._oFormSearch ) {

			this._bSetted = this._oFormSearch.indexOfQueryItem( this._sQueryItem ) !== -1;

			this._mod( '', 'lquery_set', this._bSetted );
			this._mod( '', 'lquery_unset', !this._bSetted );
		}
	}
}